import { z } from "zod";
import { CoverageStatus } from "../enums/CoverageStatus";
import { InsuranceType } from "../enums/InsuranceType";
import { dateSchema } from "../utils/DateSchema";
import { nameSchema } from "../utils/NameSchema";
import { requiredStringSchema } from "../utils/RequiredStringSchema";

export const GeneralLiabilityCoverageLimitsSchema = z.object({
  eachOccurrence: z.number(),
  damageToRentedPremises: z.number(),
  medicalExpenses: z.number(),
  personalAndADVInjury: z.number(),
  generalAggregate: z.number(),
  products: z.number(),
});

export const GeneralLiabilityCoverageOptionsSchema = z.object({
  generalAggLimitPerPolicy: z.boolean().optional(),
  generalAggLimitPerProject: z.boolean().optional(),
  generalAggLimitPerLocation: z.boolean().optional(),
  commercialGeneralLiability: z.boolean().optional(),
});

export const GeneralLiabilityPolicySchema = z.object({
  policyNumber: requiredStringSchema().max(50),
  insurer: nameSchema(),
  typeOfInsurance: InsuranceType,
  status: CoverageStatus,
  effectiveDate: dateSchema().optional(),
  expirationDate: dateSchema().optional(),
  limits: GeneralLiabilityCoverageLimitsSchema,
  options: GeneralLiabilityCoverageOptionsSchema,
});

export type GeneralLiabilityPolicy = z.infer<
  typeof GeneralLiabilityPolicySchema
>;

export type GeneralLiabilityCoverageLimits = z.infer<
  typeof GeneralLiabilityCoverageLimitsSchema
>;

export type GeneralLiabilityCoverageOptions = z.infer<
  typeof GeneralLiabilityCoverageOptionsSchema
>;
